import { Trans, useLingui } from "@lingui/react";
import { TradeOrgPages } from "src/types/tradeorgPages.ts";
import List from "./components/List.tsx";
import OrgLinks from "./components/OrgLinks.tsx";
import Text from "./components/Text.tsx";
import Title from "./components/Title.tsx";
import { Layout } from "./Layout.tsx";

const Bruktbilgruppen = () => {
  const { i18n } = useLingui();
  const pageName = TradeOrgPages.Bruktbilgruppen;

  const pageTitle = i18n._({
    id: "tradeOrgLayout.page.title",
    message: "Advantages with {tradeOrgName}",
    comment: "Page title with trade organization name",
    values: { tradeOrgName: "Bruktbilgruppen" },
  });

  const descriptionText = i18n._({
    id: "tradeOrgLayout.bruktbilgruppen.description.text",
    message:
      "The car is sold by a certified member of the Bruktbilgruppen. Buying a car from a dealer who is a certified member of the Bruktbilgruppen provides extra security.",
    comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
  });

  const advantagesList = [
    i18n.t({
      id: "tradeOrgLayout.bruktbilgruppen.section.one.advantages.itemOne",
      message: "All certified members have undergone a certification course to be able to use this label.",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.bruktbilgruppen.section.one.advantages.itemTwo",
      message: "Certified members have signed our ethical guidelines.",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
  ];

  const listTitle = i18n.t({
    id: "tradeOrgLayout.bruktbilgruppen.section.one.title",
    message: "This means, among other things, that:",
    comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
  });

  return (
    <Layout
      left={
        <>
          <Title title={pageTitle} />
          <Text text={descriptionText} />
          <div className="mt-40">
            <List title={listTitle} listElements={advantagesList} />

            <div className="mt-40 pb-40 border-b md:border-none">
              <p className="mt-16 mb-0">
                <Trans
                  id="tradeOrgLayout.bruktbilgruppen.section.two.text"
                  message="As an industry organisation, Bruktbilgruppen works continuously with information work and training for our members to keep them up to date on operations and current legislation"
                  comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                />
              </p>
            </div>
          </div>
        </>
      }
      right={<OrgLinks pageName={pageName} />}
    />
  );
};

export default Bruktbilgruppen;
